import React, { useEffect } from 'react'
import InputCustom from '../../components/elements/InputCustom'
import { VariableScriptsArchive } from './VariableScriptsArchive';
import { useSelectorCustom } from '../../components/general/general-component/abstruct-component/useSelectorCustom';
import SelectDropDown from '../../components/elements/SelectDropDown';
import TextAreaCustom from '../../components/elements/TextAreaCustom';
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar';
import { getPageList } from '../../store/Actions/ActionAccounts';
import { loadPageListScriptArchive } from '../../store/Actions/ActionScriptArchive';

function EditBasicInfo({ setIsEditImage,oneScriptsArchive, translate }) {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { page_list_scripts_archive, loadingPageListScriptsArchive } = useSelectorCustom()
    const { state, setStateCustom, setLoad, setState } = VariableScriptsArchive();
    const handleFieldChange = (name, value) => {
        setStateCustom(name, value)
    }
    useEffect(() => {
        dispatch(loadPageListScriptArchive())
        setState((prevState) => ({
            ...prevState,
            name: oneScriptsArchive?.name,
            creative_work_type_id: oneScriptsArchive?.creative_work_type?.id,
            creative_work_type_name: oneScriptsArchive?.creative_work_type?.type,
            episodes_count: oneScriptsArchive?.episodes_count,
            duration_minutes: oneScriptsArchive?.duration_minutes,
            status: oneScriptsArchive?.status,
            description: oneScriptsArchive?.description,
        }));
    }, [oneScriptsArchive])
    useEffect(()=>{
        console.log(state?.thumbnail)
        if(state?.thumbnail !== ''){
            setIsEditImage(`${process.env.REACT_APP_BASE_URL_IMAGES}${state?.thumbnail}`)
        }
        
    },[state?.thumbnail])
    return (
        <div className='d-flex' style={{ width: "80%", marginLeft: "15px", paddingTop: "10px" }} >
            <InputCustom
                label='script_name'
                iconType='pencil'
                type='text' value1={state?.name}
                onChange={(e) => setStateCustom('name', e.target.value)}
            />
            <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`}>
                <span>{translate('script_type')}</span>
                {
                    state?.creative_work_type_id && (
                        <SelectDropDown
                            options={page_list_scripts_archive?.creative_work_types?.map((type) => ({
                                label: type?.type, value: type?.id
                            }))}
                            varr={state.creative_work_type_id}
                            setVarr={(value) => setStateCustom('creative_work_type_id', value)}
                            defaultvalue={{ value: state?.creative_work_type_id, label: state?.creative_work_type_name }}
                        />
                    )
                }

            </div>
            <InputCustom
                label='episodes_count'
                iconType='pencil'
                type='number' value1={state?.episodes_count}
                onChange={(e) => setStateCustom('episodes_count', e.target.value)}
            />
            <InputCustom
                label='film_duration'
                iconType='pencil'
                type='number' value1={state?.duration_minutes}
                onChange={(e) => setStateCustom('duration_minutes', e.target.value)}
            />
            <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`}>
                <span>{translate('status')}</span>
                {
                    state?.status && (
                        <SelectDropDown
                            options={page_list_scripts_archive?.status?.map((statuss) => ({
                                label: statuss, value: statuss
                            }))}
                            varr={state.status}
                            setVarr={(value) => setStateCustom('status', value)}
                            defaultvalue={{ value: state?.status, label: state?.status }}
                        />
                    )
                }
            </div>
            <div className='w-25' >
                <InputCustom
                    label='thumbnail'
                    iconType='pencil'
                    type='file' service_name='SCRIPTS' typeFileOne
                    onChange={handleFieldChange} name='thumbnail'
                />
            </div>
            <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-text-area`} style={{ width: '48%' }}>
                <TextAreaCustom
                    label='description'
                    value={state.description}
                    onChange={(e) => setStateCustom('description', e.target.value)}
                    nameClass='textarea-gen'
                />
            </div>
        </div>
    )
}

export default EditBasicInfo